<script setup lang="ts">
import { useRouter } from 'vue-router'
const router = useRouter()
router.replace('/games')
</script>
<template><div /></template>
